import type { Localized } from "../types/i18n";
import type { ServiceType } from "../utils/serviceRequest";

/** Images are side-by-side diptychs; cards display only the right ("after") half. */
export const portfolioProjects: {
  id: string;
  image: string;
  serviceType: ServiceType;
  badge: Localized;
  title: Localized;
  alt: Localized;
}[] = [
  {
    id: "hotel",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/9ee7f4dd-84b4-4342-ba9b-7be00ef3e96f.jpg",
    serviceType: "hospitality",
    badge: { en: "Hotel Housekeeping", es: "Limpieza de Hoteles" },
    title: { en: "Guest-ready hotel rooms, every turnover", es: "Habitaciones listas para huéspedes en cada cambio" },
    alt: { en: "Spotless hotel room with a freshly made bed after professional housekeeping", es: "Habitación de hotel impecable con la cama recién hecha tras la limpieza profesional" },
  },
  {
    id: "office",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/f76b2ac2-3ff4-4c24-b488-425cec95aaca.jpg",
    serviceType: "cleaning",
    badge: { en: "Office Cleaning", es: "Limpieza de Oficinas" },
    title: { en: "Clean, organized corporate workspaces", es: "Espacios corporativos limpios y organizados" },
    alt: { en: "Clean open-plan office with polished floors after commercial cleaning", es: "Oficina abierta limpia con pisos pulidos tras la limpieza comercial" },
  },
  {
    id: "commercial",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/e5dc181d-3a98-4b14-9e9e-2bdc3c0393b3.jpg",
    serviceType: "cleaning",
    badge: { en: "Commercial Services", es: "Servicios Comerciales" },
    title: { en: "Pristine retail and commercial spaces", es: "Locales comerciales y tiendas impecables" },
    alt: { en: "Pristine retail store with polished floors and clean displays", es: "Tienda impecable con pisos pulidos y vitrinas limpias" },
  },
];
